const APP_NAME = 'AutoEat'

export default APP_NAME
